import React, { useState, useEffect } from "react";
import { TrashIcon, MapIcon } from "@heroicons/react/24/outline";
import { Table } from "../../../components/table";

function Tours({
  handleToursAddMode,
  setIsCheckpointsAddMode,
  fetchToursList,
  isLoading,
  handleDeleteTour,
  toursListData,
}) {
  useEffect(() => {
    fetchToursList();
  }, []);

  /// Table columns ///
  const columns = React.useMemo(
    () => [
      {
        Header: "Name",
        accessor: "tour_name",
        // Use a custom cell to render the link
        Cell: ({ row }) => (
          <div>
            <a
              onClick={() => {
                handleToursAddMode(row.original.id);
                setIsCheckpointsAddMode(true);
              }}
              className="text-gray-800 dark:text-gray-100 hover:text-gray-900 dark:hover:text-white hover:underline cursor-pointer"
            >
              {row.values.tour_name}
            </a>
          </div>
        ),
      },
      {
        Header: "Description",
        accessor: "tour_description",
      },
      {
        Header: "Checkpoints",
        accessor: "checkpoint_names",
      },
      {
        Header: "",
        id: "delete",
        accessor: (str) => "delete",
        Cell: ({ row }) => (
          <button
            onClick={() =>
              handleDeleteTour(row.original.tour_name, row.original.id)
            }
            className="text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 transition-colors duration-150"
          >
            <TrashIcon className="h-4 w-4 shrink-0" />
          </button>
        ),
      },
    ],
    []
  );

  return (
    <div>
      <Table
        data={toursListData || []}
        columns={columns}
        isLoading={isLoading || toursListData === undefined}
        emptyState={
          <div className="flex flex-col items-center justify-center h-72">
            <MapIcon className="h-10 w-10 text-gray-300 dark:text-gray-600" />
            <p className="mt-3 text-sm text-gray-400 dark:text-gray-500 text-center">
              No tours yet
            </p>
          </div>
        }
      />
    </div>
    /* {typeof toursListData === "undefined" ? (
        <p>Loading...</p>
      ) : (
        <table className="mt-2 w-full">
          <thead className="text-xs uppercase text-left">
            <tr>
              <th className="pl-6 font-normal text-gray-500">Name</th>
              <th className="pl-6 font-normal text-gray-500">Description</th>
              <th className="pl-6 font-normal  text-gray-500">Checkpoints</th>
              <th className="pl-6 font-normal text-gray-500">&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            {toursListData.map((tour) => (
              <tr
                className="border-solid border-b border-gray-100"
                key={tour.id}
              >
                <td className="py-4 pl-6 pr-2 whitespace-nowrap text-sm ">
                  <a
                    onClick={() => {
                      handleToursAddMode(tour.id);
                      setIsCheckpointsAddMode(true);
                    }}
                    className="text-gray-500 hover:text-gray-600 hover:underline capitalize cursor-pointer"
                  >
                    {tour.tour_name}
                  </a>
                </td>
                <td className="py-4 pl-6 pr-2 whitespace-nowrap text-sm text-gray-500">
                  {tour.tour_description}
                </td>
                <td className="py-4 pl-6 pr-2 whitespace-nowrap text-sm text-gray-500">
                  {tour.checkpoint_names}
                </td>
                <td className="py-4 pl-6 pr-2 whitespace-nowrap text-right text-sm font-medium  hover:text-gray-600">
                  <TrashIcon className="h-4 w-4 shrink-0 hover:cursor-pointer hover:text-gray-600" />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )} */
  );
}

export { Tours };
